import { request, type ApiResponse } from "../client";
import type { VlanGenerateIn, VlanGenerationOut, VlanTemplateOut } from "../types/allocation";

export const allocationVlans = {
  vlanTemplate: (): Promise<ApiResponse<VlanTemplateOut[]>> =>
    request<VlanTemplateOut[]>("GET", "/api/v1/allocations/vlan-template"),

  generate: (siteSlug: string, body: VlanGenerateIn): Promise<ApiResponse<VlanGenerationOut>> =>
    request<VlanGenerationOut>(
      "POST",
      `/api/v1/allocations/sites/${encodeURIComponent(siteSlug)}/vlans`,
      body,
    ),
};
